import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Share = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...rest}
    >
      <path d="M12 6c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .223.029.439.075.649l-3.22 2.012A2.97 2.97 0 0 0 4 5C2.346 5 1 6.346 1 8s1.346 3 3 3a2.97 2.97 0 0 0 1.855-.661l3.22 2.012c-.046.21-.075.426-.075.649 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3a2.97 2.97 0 0 0-1.855.661l-3.22-2.012C6.971 8.439 7 8.223 7 8c0-.223-.029-.439-.075-.649l3.22-2.012A2.97 2.97 0 0 0 12 6z" />
      <defs>
        <path id="a" d="M0 0h16v16H0z" />
      </defs>
    </svg>
  );
};

Share.displayName = 'Share';
